export default function formattedDate(date){
    if(date == null || date == ''){
        return null;
    }else{
        let localDate = new Date(date);
        return localDate.toLocaleDateString('en-CA');
    }
};
